// extracted by mini-css-extract-plugin
export var parcelRow = "_vj-0";